@import 'styles/blaze/mixins';

.empty {
  display: flex;
  width: 100%;
  height: 100%;
  padding: 18px 9px 19px 9px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  background: transparent;
  flex-direction: column;
  gap: 10px;
}

.emptyText {
  @include xs-sohne-medium;
  color: var(--dark-40);
  text-align: center;
  font-size: 10px;
}

.emptyDesign {
  width: 30px;
  height: 30px;
  flex-shrink: 0;
  border-radius: 1.192px;
  border: 2.86px solid #fff;
  background: conic-gradient(
      from 45deg at 5% 95%,
      rgba(236, 236, 236, 0.39) 0.019790558726526797deg,
      rgba(179, 179, 179, 0.39) 0.045117505942471325deg,
      rgba(116, 116, 116, 0.32) 39.80503052473068deg,
      rgba(206, 206, 206, 0.32) 301.39529943466187deg
    ),
    #fff;
}
